import React, { useState, useRef, useEffect } from 'react'; 
import { Link } from "react-router-dom";
import "bootstrap-daterangepicker/daterangepicker.css";
import { Dropdown, Tab, Nav, Modal } from "react-bootstrap";
import { get_AstroData, get_AstrologerSingleData, } from '../../../store/actions/CommanAction';
import { useDispatch, useSelector } from 'react-redux';
import { setAstroId } from '../../../store/Action_Types';
import { AddUpdate } from '../../../ApiMethods/ApiMethods';
import swal from "sweetalert";
import DataTable from 'react-data-table-component';
import { customStyles } from '../Utility/Utility';
import user from './../../../images/task/user.jpg';
import { Bold, ColorSelectorView } from 'ckeditor5';
import Loader from '../Loader/Loader';
import AstrologerAdd from './AstrologerAdd';
import { BsThreeDotsVertical } from "react-icons/bs";
import * as XLSX from "xlsx";


const AstrologerList = () => {
    const dispatch = useDispatch()
    const effectRan = useRef(false);
    const AstroData = useSelector((state) => state.feedBackReducer.AstroData);
   
    const customerID = Number(sessionStorage.getItem('ID'));
    const AstrologerSingleData = useSelector((state) => state.feedBackReducer.AstrologerSingleData);

    const selectedAstroId = useSelector((state) => state.feedBackReducer.selectedAstroId);
    const [IsActive, setIsActive] = useState('1');
    const [searchQuery, setSearchQuery] = useState('');
    const [AstrologerID, seAstrologerID] = useState('');
    const [EditModalAstro, setEditModalAstro] = useState(false);
    const [startTime, setStartTime] = useState('');
    const [endTime, setEndTime] = useState('');
    const [searchQuery1, setSearchQuery1] = useState("");
    const [mobileNumber, setMobileNumber] = useState("");
    const [name, setName] = useState("");
    const [location, setLocation] = useState("");
    const [loading, setloading] = useState(false);
    const [hasFetched, setHasFetched] = useState(false);
    const [timeoutId, setTimeoutId] = useState(null);
    const [showFilters, setShowFilters] = useState(false);
    const [showFullEditModal, setShowFullEditModal] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [showAddAstroModal, setShowAddAstroModal] = useState(false);

    const [freeChatModel, setFreeChatModel] = useState(false)
    const [amount, setAmount] = useState(false);
    const [notbusymodel, setnotmodel] = useState(false)


    //-------------------------Review-------------------------                        
    const [ReviewData, setReviewData] = useState({
        'AstrologerID': AstrologerID, 'OriginalPricePerMin': '', 'PricePerMin': '', 'FreePerMin': '', 'Reviews': '', 'Rating': '', 'ModifiedByUser': '1', "PujaSuggestionPer": "", "GemStoneSuggestionPer": ""
    });

    const [openMenuRow, setOpenMenuRow] = useState(null);


    const handleAddAstrologerClick = (ID) => {
        dispatch(setAstroId(ID));
    };
    useEffect(() => {
        seAstrologerID(AstrologerID)

    }, [AstrologerID])

    useEffect(() => {
        if (IsActive) {
            const today = new Date();
            const formattedToday = today.toISOString().split('T')[0];
            const CreatedFrom = formattedToday;
            const CreatedTo = formattedToday;
            const IsActive = "1"
            setStartTime(CreatedFrom);
            setEndTime(CreatedTo);

            dispatch(get_AstroData(IsActive, "", "", name, mobileNumber, location, setloading));
        } else {

            const today = new Date();
            const formattedToday = today.toISOString().split('T')[0];
            const CreatedFrom = formattedToday;
            const CreatedTo = formattedToday;
            const IsActive = "0";
            setStartTime(CreatedFrom);
            setEndTime(CreatedTo);
            dispatch(get_AstroData(IsActive, "", "", name, mobileNumber, location, setloading));
        }
    }, []);



    useEffect(() => {
        handleReset()
    }, [])




    useEffect(() => {

        if (!name && !location && !mobileNumber) {
            dispatch(get_AstroData(IsActive, startTime, endTime, '', '', '', setloading));
            return;
        }


        if (name.length < 3 && location.length < 3 && mobileNumber.length < 3) return;

        if (timeoutId) clearTimeout(timeoutId);

        const newTimeoutId = setTimeout(() => {
            setloading(true);
            dispatch(get_AstroData(IsActive, startTime, endTime, name, mobileNumber, location, setloading));
            setloading(false);
        }, 500);

        setTimeoutId(newTimeoutId);

        return () => clearTimeout(newTimeoutId);
    }, [name, location, mobileNumber]);
    const handleSearch = () => {
        dispatch(get_AstroData(

            IsActive,
            startTime,
            endTime,
            name,
            mobileNumber,
            location
        ));
        setCurrentPage(1);
    };


    const columns = [
        { name: 'ID', selector: (row) => row.ID, sortable: true },
        {
            name: <p className='text-end' style={{ position: 'absolute', top: '7px', right: 50 }}>Action</p>,
            cell: row => (
                <div style={{ position: 'absolute', top: 4, right: 50 }}>
                    <Dropdown>
                        <Dropdown.Toggle variant="" as="div" className="btn-link i-false">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z" stroke="#342E59" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M12 6C12.5523 6 13 5.55228 13 5C13 4.44772 12.5523 4 12 4C11.4477 4 11 4.44772 11 5C11 5.55228 11.4477 6 12 6Z" stroke="#342E59" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M12 20C12.5523 20 13 19.5523 13 19C13 18.4477 12.5523 18 12 18C11.4477 18 11 18.4477 11 19C11 19.5523 11.4477 20 12 20Z" stroke="#342E59" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        </Dropdown.Toggle>
                        <Dropdown.Menu alignRight={true} className="dropdown-menu-right">
                            <Dropdown.Item style={{ color: "black" }} onClick={() => handleEditClick(row)} >Reviews/Pricing per minute</Dropdown.Item>
                            <Dropdown.Item className={row.IsActive ? "text-danger" : "text-success"}
                                onClick={() => { handleToggleStatusClick(row.ID, true, '0'); }}>
                                Inactive
                            </Dropdown.Item>
                            <Dropdown.Item
                                className={row.IsBlock ? "text-warning" : "text-danger"}
                                onClick={() => {
                                    handleToggleStatusClick1(row.ID, row.IsBlock, false);

                                }}
                            >
                                {row.IsBlock ? "Unblock" : "Block"}
                            </Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>
                </div>
            )
        },
        {
            name: 'Image',
            selector: row => row.AvatarUrl,
            sortable: true,
            cell: row => (
                <div className="concierge-bx d-flex align-items-center">
                    {
                        row.AvatarUrl ? (
                            <img className="me-3 rounded" src={`https://${row.AvatarUrl.replace(/\\/g, "/")}`} alt="User Avatar" />
                        ) :
                            <img className="me-3 rounded" src={user} />
                        //  (<span className="me-3 rounded"></span>)
                    }
                </div>
            ),
            // sortable: true
        },
        {
            name: 'Name',
            selector: row => row.DisplayName,
            sortable: true,
            cell: row => (
                <div style={{ paddingRight: "600px" }}>

                    <h5 className="fs-16 mb-0 text-nowrap">
                        <Link to={"/astrohome"} onClick={() => { handleAddAstrologerClick(row.ID); seAstrologerID(row.ID); }} className="text-black"   >
                            {row.DisplayName}
                        </Link>
                    </h5>
                    <span className="text-primary fs-14 ">{row.EMPID}</span>
                </div>
            ),

        },
        { name: 'Mobile Number', selector: (row) => row.RegMobileNo, sortable: true },
        { name: 'Exp', selector: (row) => row.ExperiencedYears, sortable: true },
        { name: 'Rate', selector: (row) => row.PricePerMin, sortable: true },



    ];

    const columns1 = [
        { name: 'ID', selector: (row) => row.ID, sortable: true },
        {
            name: <p className='text-end' style={{ position: 'absolute', top: '7px', right: 50 }}>Action</p>,
            cell: row => (
                <div style={{ position: 'absolute', top: 4, right: 50 }}>
                    <Dropdown>
                        <Dropdown.Toggle variant="" as="div" className="btn-link i-false">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z" stroke="#342E59" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M12 6C12.5523 6 13 5.55228 13 5C13 4.44772 12.5523 4 12 4C11.4477 4 11 4.44772 11 5C11 5.55228 11.4477 6 12 6Z" stroke="#342E59" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M12 20C12.5523 20 13 19.5523 13 19C13 18.4477 12.5523 18 12 18C11.4477 18 11 18.4477 11 19C11 19.5523 11.4477 20 12 20Z" stroke="#342E59" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        </Dropdown.Toggle>
                        <Dropdown.Menu alignRight={true} className="dropdown-menu-right">
                            <Dropdown.Item className={row.IsActive ? "text-danger" : "text-success"}
                                onClick={() => {
                                    handleToggleStatusClick(row.ID, false, '1');
                                }}>
                                Activate
                            </Dropdown.Item>

                        </Dropdown.Menu>
                    </Dropdown>
                </div>
            )
        },
        {
            name: 'Image',
            selector: row => row.AvatarUrl,
            sortable: true,
            cell: row => (
                <div className="concierge-bx d-flex align-items-center  ">
                    {
                        row.AvatarUrl ? (
                            <img className="me-3 rounded" src={`https://${row.AvatarUrl.replace(/\\/g, "/")}`} alt="User Avatar" />
                        ) :
                            <img className="me-3 rounded" src={user} />
                        //  (<span className="me-3 rounded"></span>)
                    }
                </div>
            ),
            sortable: true
        },

        {
            name: 'Name',
            cell: row => (
                <div>

                    <h5 className="fs-16 mb-0 text-nowrap">
                        <Link to={"/astrohome"} onClick={() => { handleAddAstrologerClick(row.ID); seAstrologerID(row.ID); }} className="text-black"   >
                            {row.DisplayName}
                        </Link>
                    </h5>
                    <span className="text-primary fs-14 ">{row.EMPID}</span>
                </div>
            ),
            sortable: true
        },
        { name: 'Mobile Number', selector: (row) => row.RegMobileNo, sortable: true },
        { name: 'Rate', selector: (row) => row.PricePerMin, sortable: true },
        { name: 'Exp', selector: (row) => row.ExperiencedYears, sortable: true },



    ];

    const handleEditClick = (row) => {
        seAstrologerID(row?.ID);
        setEditModalAstro(true);
        dispatch(get_AstrologerSingleData(row?.ID));
        setReviewData({});
    };
    const reviewModel = () => {
        setEditModalAstro(true)
    }

    useEffect(() => {
        if (AstrologerSingleData && AstrologerSingleData.length > 0) {

            setReviewData({
                ...ReviewData,
                AstrologerID: AstrologerID,
                OriginalPricePerMin: AstrologerSingleData[0]?.OriginalPricePerMin,
                PricePerMin: AstrologerSingleData[0]?.PricePerMin,
                FreePerMin: AstrologerSingleData[0]?.FreeEarningAmount,
                Reviews: AstrologerSingleData[0]?.Reviews,
                Rating: AstrologerSingleData[0]?.Rating,
                GemStoneSuggestionPer: AstrologerSingleData[0]?.GemStoneSuggestionPer,
                PujaSuggestionPer: AstrologerSingleData[0]?.PujaSuggestionPer
            });
            setAmount(AstrologerSingleData[0]?.FreeState);
        }

    }, [AstrologerSingleData, AstrologerID]);






    useEffect(() => {
        if (startTime) sessionStorage.setItem("astrostartTime", startTime);
        if (endTime) sessionStorage.setItem("astroendTime", endTime);
    }, [startTime, endTime]);


    const UpdateAstro = async (e) => {
        let error = false; let errorMsg = '';
        if (ReviewData.OriginalPricePerMin === "") {
            error = true; errorMsg = 'Please fill OriginalPricePerMin.';
        }
        else if (ReviewData.Reviews === "") {
            error = true; errorMsg = 'Please fill Reviews.';
        } else if (ReviewData.Rating === "") {
            error = true; errorMsg = 'Please fill Rating..';
        }
        if (!error) {
            await AddUpdate('Astrologer/UpdateAstrologerReview', ReviewData);
            swal('Good job!', 'Successfully Updated', "success");
            dispatch(get_AstroData(IsActive, startTime, endTime, name, mobileNumber, location));
            setEditModalAstro(false);
        } else {
            swal('Oops', errorMsg, "error");
        }
    };




    const handleChange = (e) => {
        const allowedFields = [
            'Reviews',
            'OriginalPricePerMin',
            'Rating',
            'PricePerMin',
            'GemStoneSuggestionPer',
            'PujaSuggestionPer'
        ];

        if (allowedFields.includes(e.target.name)) {
            const ele = e.target.value.replace(/[^0-9.]/g, "");

            if (ele.includes('.')) {
                if (ele.length === 16) {
                    setReviewData({ ...ReviewData, [e.target.name]: ele });
                } else {
                    const decimalPart = ele.substr(ele.indexOf('.') + 1).slice(0, 2);
                    const checkDot = decimalPart.match(/\./g);

                    if (!checkDot) {
                        setReviewData({
                            ...ReviewData,
                            [e.target.name]:
                                ele.substring(0, ele.indexOf(".")) + "." + decimalPart,
                        });
                        return;
                    } else {
                        return;
                    }
                }
            } else {
                setReviewData({ ...ReviewData, [e.target.name]: ele });
            }
        } else {

            setReviewData({ ...ReviewData, [e.target.name]: e.target.value });
        }
    };




    const handleReset = () => {
        const today = new Date().toISOString().split("T")[0];

        setStartTime("");
        setEndTime("");
        setMobileNumber("");
        setName("");
        setLocation("");
    };

    const handleRowClick = (row) => {
        dispatch(setAstroId(row.ID));
        dispatch(get_AstrologerSingleData(row.ID));
        setShowFullEditModal(true);
    };

    useEffect(() => {
        const handleClick = () => setOpenMenuRow(null);
        if (openMenuRow !== null) {
            document.addEventListener('mousedown', handleClick);
            return () => document.removeEventListener('mousedown', handleClick);
        }
    }, [openMenuRow]);


    const totalRows = AstroData ? AstroData.length : 0;
    const totalPages = Math.ceil(totalRows / rowsPerPage);
    const paginatedAstroData = AstroData
        ? AstroData.slice((currentPage - 1) * rowsPerPage, currentPage * rowsPerPage)
        : [];
   
    const startRow = totalRows === 0 ? 0 : (currentPage - 1) * rowsPerPage + 1;
    const endRow = Math.min(currentPage * rowsPerPage, totalRows);

    const handlePageChange = (page) => {
        if (page >= 1 && page <= totalPages) setCurrentPage(page);
    };




    const handleToggleStatusClick = async (astrologerID, currentStatus) => {
        const newStatus = !currentStatus;

        const postData = {
            AstrologerID: astrologerID,
            DeleteByUser: customerID,
            IsActive: newStatus ? '1' : '0',
        };

        await AddUpdate('Astrologer/Delete_Astrologer', postData);


        dispatch(get_AstroData(!newStatus));

        swal(
            'Good job!',
            `Successfully ${newStatus ? 'Activated' : 'Deactivated'}`,
            'success'
        );
    };




    const handleToggleStatusClick1 = async (
        AstroId,
        currentIsBlock,
        currentStatus
    ) => {

        const postData = {
            AstroId: AstroId,
            IsBlock: !currentIsBlock,
            BlockReason: null,

        };

        await AddUpdate("Astrologer/UpdateAstrologerBlock", postData);



        const formatDate = (dateTime) => {
            if (!dateTime) return null;
            const date = new Date(dateTime);
            const yyyy = date.getFullYear();
            const mm = String(date.getMonth() + 1).padStart(2, "0");
            const dd = String(date.getDate()).padStart(2, "0");
            return `${yyyy}-${mm}-${dd}`;
        };

        const formattedStartDate = formatDate(startTime);
        const formattedEndDate = formatDate(endTime);
        const CreatedFrom = formattedStartDate;
        const CreatedTo = formattedEndDate;

        dispatch(get_AstroData(currentStatus ? "0" : "1", CreatedFrom, CreatedTo, name, mobileNumber, location, setloading));


        swal(
            "Success",
            `${!currentIsBlock ? "Astrologer has been blocked" : "Astrologer has been unblocked"
            }`,
            "success"
        );
    };
    const updateapifunction = () => {
       
        dispatch(get_AstroData(1));
    }

    const updatefreechat = async () => {
        let error = false;
        let errormsg = "";

        const insertdata = {
            FreeState: amount,
            AstroID: AstrologerID,
        };
        const secondinsert = {
            AstroID: AstrologerID,
            FreeEarningAmount: ReviewData?.FreePerMin,
        }

        try {
            await AddUpdate("Astrologer/Update_FreeState", insertdata);
            await AddUpdate("Astrologer/Update_FreeEarningAmount", secondinsert);

            swal("Good job!", "Successfully updated", "success");
            setFreeChatModel(false);
        } catch (err) {
            swal("Error", "Something went wrong while updating.", "error");
        }
    };

    const updatenotbusychat = async () => {
        let error = false;
        let errormsg = "";

        const insertdata = {
            BusyTime: null,
            IsBusy: "0",
            AstroID: AstrologerID,
        };

        try {
            await AddUpdate("Astrologer/Update_IsBusy", insertdata);

            swal("Good job!", "Successfully updated", "success");
            setnotmodel(false);
        } catch (err) {
            swal("Error", "Something went wrong while updating.", "error");
        }
    };

    const Freechat = (row) => {

        setAmount("");
        seAstrologerID(row?.id);


        seAstrologerID(row?.ID);

        dispatch(get_AstrologerSingleData(row?.ID));
        setReviewData({});

        setFreeChatModel(true)
    }
    const Notbusychat = (id) => {
        setnotmodel(true)
        seAstrologerID(id);
    }


    const handleExportToExcel = () => {
        if (!AstroData || AstroData.length === 0) {
            swal("No data available to export!", "", "info");
            return;
        }

        const exportData = AstroData.map((row, index) => ({
            "S.No": index + 1,
            "ID": row.ID,
            "Name": row.DisplayName,
            "Mobile Number": row.RegMobileNo,
            "Gender": row.Gender || "N/A",
            "Rating": row.Review || 0,
            "Total Orders": row.Orders || 0,
            "Followers": row.Totalfollower || 0,
            "Waiting List": row.WaitListCount || 0,
            "Status": row.IsActive ? "Active" : "Inactive"
        }));


        const worksheet = XLSX.utils.json_to_sheet(exportData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Astrologers List");


        XLSX.writeFile(workbook, "Astrologers_List.xlsx");


        setTimeout(() => {
            swal("Download complete!", "Your astrologers list has been saved.", "success");
        }, 1000);
    };





    return (
        <div className="astro-list-container" style={{ background: '#fff', borderRadius: '10px', padding: '24px', marginTop: '20px' }}>

            <div className="astro-list-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1.5rem' }}>
                <h2 style={{ color: '#f7931e', fontWeight: 700 }}>Astrologers List</h2>
                <button className="btn btn-warning mb-3"


                    onClick={() => {
                        dispatch(setAstroId(null));
                        setShowAddAstroModal(true);
                    }}

                >
                    Add Astrologer
                </button>
            </div>

            <Modal show={showAddAstroModal} onHide={() => setShowAddAstroModal(false)} size="xl" scrollable>
                <Modal.Header closeButton>
                    <Modal.Title ><h2 style={{ color: '#f7931e' }}>Add Astrologer</h2></Modal.Title>
                </Modal.Header>
                <Modal.Body style={{ height: 'calc(100vh - 50px)', overflowY: 'scroll' }}>
                    <AstrologerAdd onClose={() => setShowAddAstroModal(false)} />
                </Modal.Body>
            </Modal>

            <div>
                <div className='row'>
                    <div className="col-md-3 mb-3">
                        <div className="form-group">
                            <input
                                type="text"
                                name="Title"
                                autoComplete="off"
                                required
                                value={name}
                                placeholder="Enter name"
                                onChange={e => setName(e.target.value.replace(/[^A-Za-z\s]/g, ''))}
                            />
                        </div>

                    </div>

                    <div className="col-md-3 mb-3">
                        <div className="form-group">
                            <input
                                type="text"
                                // className="form-control"
                                placeholder="Search Mobile"
                                value={mobileNumber}

                                onChange={e => setMobileNumber(e.target.value.replace(/[^0-9]/g, '').slice(0, 10))}
                            />
                        </div>

                    </div>



                    <div className="col-md-3 mb-3">
                        <div className="form-group">
                            <select
                                value={IsActive}
                                onChange={(e) => {
                                    const selectedValue = e.target.value;
                                    setIsActive(selectedValue);
                                    dispatch(get_AstroData(
                                        selectedValue,
                                        startTime,
                                        endTime,
                                        name,
                                        mobileNumber,
                                        location,
                                        setloading
                                    ));
                                    setCurrentPage(1);
                                }}
                            >
                                <option value="1">Active</option>
                                <option value="0">Inactive</option>
                            </select>

                        </div>

                    </div>

                    <div className='col-md-3 mb-3'>
                        <div className="astro-list-filters" style={{ display: 'flex', gap: '1rem', marginBottom: '1.5rem', flexWrap: 'wrap' }}>
                            <button className="btn btn-warning" style={{ borderRadius: '8px', fontWeight: 500 }} onClick={() => handleSearch()}>Apply Filters</button>


                            <button
                                className="btn btn-warning"
                                style={{ borderRadius: '8px', fontWeight: 500 }}
                                onClick={handleExportToExcel}
                            >
                                Export to Excel
                            </button>
                        </div>
                    </div>

                </div>
            </div>



            <div style={{ maxHeight: '400px', overflowY: 'auto' }} className="table-responsive">
                <table className="table astro-list-table" style={{ width: '100%' }}>
                    <thead

                        style={{
                            position: 'sticky',
                            top: 0,
                            background: '#0d2235',
                            color: '#fff',
                            fontSize: '13px',
                            zIndex: 2
                        }}
                    >
                        <tr>
                            <th style={{ fontSize: "13px" }}>Image</th>

                            <th style={{ fontSize: "13px" }}>Name</th>
                            <th style={{ fontSize: "13px" }}>Mobile#</th>
                            <th style={{ fontSize: "13px" }}>Gender</th>
                            <th style={{ fontSize: "13px" }}>Rating</th>
                            {/* <th style={{ fontSize: "13px" }}>Skill</th> */}
                            <th style={{ fontSize: "13px" }}>Total Order</th>
                            <th style={{ fontSize: "13px" }}>Followers</th>
                            <th style={{ fontSize: "13px" }}>WaitingList</th>
                            <th style={{ fontSize: "13px" }}>Status</th>
                            <th style={{ fontSize: "13px" }}>Reviews/Pricing</th>
                            <th style={{ fontSize: "13px" }}>Free/Paid</th>
                            <th style={{ fontSize: "13px" }}>Free Chat</th>
                            <th style={{ fontSize: "13px" }}>Not busy</th>
                        </tr>
                    </thead>
                    <tbody>
                        {(paginatedAstroData && paginatedAstroData.length > 0 ? paginatedAstroData : []).map((row, idx) => (
                            <tr key={row.ID || idx}>
                                <td style={{ cursor: 'pointer' }} onClick={() => handleRowClick(row)}>
                                    <img src={row.AvatarUrl ? `https://${row.AvatarUrl.replace(/\\/g, "/")}` : user} alt="profile" className="astro-img" style={{ width: 40, height: 40, borderRadius: '50%' }} />
                                </td>

                                <td style={{ cursor: 'pointer', fontWeight: "Bold" }} onClick={() => handleRowClick(row)}>{`${row.DisplayName}(${row.ID})`}</td>
                                <td>{row.RegMobileNo}</td>
                                <td>{row.Gender || 'N/A'}</td>
                                <td>{row.Review || 0}</td>
                                {/* <td>{row.skills || 'N/A'}</td> */}
                                <td>{row.Orders || 0}</td>
                                <td>{row.Totalfollower || 0}</td>
                                <td>{row.WaitListCount || 0}</td>

                                <td>
                                    <td >
                                        <div className="form-check form-switch">
                                            <input style={{ cursor: "pointer" }}
                                                className="form-check-input"
                                                type="checkbox"
                                                role="switch"
                                                id={`toggle-${row.ID}`}
                                                checked={row.IsActive}
                                                onChange={() =>
                                                    handleToggleStatusClick(row.ID, row.IsActive)
                                                }
                                            />
                                            <label className="form-check-label" htmlFor={`toggle-${row.ID}`}>
                                                {row.IsActive ? 'Active' : 'Inactive'}
                                            </label>
                                        </div>
                                    </td>

                                </td>


                                <td style={{ textAlign: 'center', verticalAlign: 'middle' }}>
                                    <span
                                        onClick={() => handleEditClick(row)}
                                        style={{
                                            fontSize: '20px',
                                            cursor: 'pointer',
                                            display: 'inline-flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                        }}
                                    >
                                        <BsThreeDotsVertical />
                                    </span>
                                </td>

                                <td>{row.FreeState ? "Not free" : "Free"}</td>

                                <td style={{ textAlign: 'center', verticalAlign: 'middle' }}>
                                    <span
                                        onClick={() => Freechat(row)}
                                        style={{
                                            fontSize: '20px',
                                            cursor: 'pointer',
                                            display: 'inline-flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                        }}
                                    >
                                        <BsThreeDotsVertical />
                                    </span>
                                </td>


                                <td style={{ textAlign: 'center', verticalAlign: 'middle' }}>
                                    <span
                                        onClick={() => Notbusychat(row.ID)}
                                        style={{
                                            fontSize: '20px',
                                            cursor: 'pointer',
                                            display: 'inline-flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                        }}
                                    >
                                        <BsThreeDotsVertical />
                                    </span>
                                </td>



                            </tr>
                        ))}
                    </tbody>
                </table>
                {(!AstroData || AstroData.length === 0) && (
                    <div className="text-center py-4">There are no data to display</div>
                )}
            </div>

            {totalPages > 1 && (
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', margin: '20px 0' }}>
                    <span>Rows per page:</span>
                    <select
                        value={rowsPerPage}
                        onChange={e => {
                            setRowsPerPage(Number(e.target.value));
                            setCurrentPage(1);
                        }}
                        style={{ margin: '0 8px' }}
                    >
                        {[5, 10, 25, 50, 100].map(n => (
                            <option key={n} value={n}>{n}</option>
                        ))}
                    </select>
                    <span style={{ margin: '0 16px' }}>{startRow}-{endRow} of {totalRows}</span>
                    <button className="btn" style={{ fontSize: '1rem', minWidth: '40px' }} onClick={() => setCurrentPage(1)} disabled={currentPage === 1}>{' ⏮'}</button>
                    <button className="btn" style={{ fontSize: '1rem', minWidth: '40px' }} onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))} disabled={currentPage === 1}>{' ◀'}</button>
                    <button className="btn" style={{ fontSize: '1rem', minWidth: '40px' }} onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))} disabled={currentPage === totalPages}>{' ▶'}</button>
                    <button className="btn" style={{ fontSize: '1rem', minWidth: '40px' }} onClick={() => setCurrentPage(totalPages)} disabled={currentPage === totalPages}>{' ⏭'}</button>
                </div>
            )}

            <Modal className="modal fade" show={EditModalAstro} onHide={() => setEditModalAstro(false)}>
                <div>
                    {(!AstrologerSingleData || AstrologerSingleData.length === 0) ? (
                        <div style={{ padding: 40, textAlign: 'center' }}>Loading...</div>
                    ) : (
                        <form>
                            <div className="modal-header">
                                <h4 className="modal-title fs-20">Reviews/Rating/Pricing per minute</h4>
                                <button type="button" className="btn-close" data-dismiss="modal" onClick={() => setEditModalAstro(false)}></button>
                            </div>
                            <div className="modal-body">
                                <i className="flaticon-cancel-12 close" data-dismiss="modal"></i>
                                <div className="add-contact-box">
                                    <div className="add-contact-content">
                                        
                                    </div>
                                    <div className='row'>
                                        <div className="form-group mb-3 col-md-6">
                                            <label className="text-black font-w500">Original Price</label>
                                            <div className="contact-name">
                                                <input type="text" className="form-control" autoComplete="off"
                                                    name="OriginalPricePerMin" required="required"
                                                    placeholder="Enter Your Original Price "
                                                    value={ReviewData?.OriginalPricePerMin || ''}
                                                    onChange={handleChange}
                                                />
                                                <span className="validation-text"></span>
                                            </div>
                                        </div>


                                        <div className="form-group mb-3 col-md-6">
                                            <label className="text-black font-w500">Current Price</label>
                                            <div className="contact-name">
                                                <input type="text" className="form-control" autoComplete="off"
                                                    name="PricePerMin" required="required"
                                                    placeholder="Enter Your Current Price"
                                                    value={ReviewData?.PricePerMin || ''}
                                                    onChange={handleChange}
                                                />
                                                <span className="validation-text"></span>
                                            </div>
                                        </div>



                                    </div>



                                    <div className='row'>
                                        <div className="form-group mb-3 col-md-6">
                                            <label className="text-black font-w500">GemStone Suggestion %</label>
                                            <div className="contact-name">
                                                <input type="number" className="form-control" autoComplete="off"
                                                    name="GemStoneSuggestionPer" required="required"
                                                    placeholder="GemStone Suggestion %"
                                                    value={ReviewData?.GemStoneSuggestionPer || ''}
                                                    onChange={handleChange}
                                                />
                                                <span className="validation-text"></span>
                                            </div>
                                        </div>


                                        <div className="form-group mb-3 col-md-6">
                                            <label className="text-black font-w500">Puja Suggestion %</label>
                                            <div className="contact-name">
                                                <input type="number" className="form-control" autoComplete="off"
                                                    name="PujaSuggestionPer" required="required"
                                                    placeholder=" Puja Suggestion %"
                                                    value={ReviewData?.PujaSuggestionPer || ''}
                                                    onChange={handleChange}
                                                />
                                                <span className="validation-text"></span>
                                            </div>
                                        </div>




                                    </div>



                                </div>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-primary" onClick={UpdateAstro}>Update</button>
                                <button type="button" className="btn btn-danger" onClick={() => setEditModalAstro(false)}> <i className="flaticon-delete-1"></i> Close</button>
                            </div>
                        </form>
                    )}
                </div>
            </Modal>
            <Modal className="modal fade" show={showFullEditModal} onHide={() => setShowFullEditModal(false)} size="xl" style={{ maxWidth: "130vw", width: "100vw" }}>
                <AstrologerAdd astrologerId={selectedAstroId} onClose={() => setShowFullEditModal(false)} refereshfunction={updateapifunction} />
            </Modal>


            <Modal
                className="modal fade "
                show={freeChatModel}
                onHide={setFreeChatModel}
                backdrop="static"

            >
                <div className="" role="document">
                    <div className="">
                        <form>
                            <div className="modal-header">
                                <h4 className="modal-title fs-20">Free Chat</h4>

                                <button
                                    type="button"
                                    className="btn-close"
                                    onClick={() => setFreeChatModel(false)}
                                    data-dismiss="modal"
                                ></button>
                            </div>

                            <div className="modal-body p-3">
                                <i
                                    className="flaticon-cancel-12 close"
                                    data-dismiss="modal"
                                ></i>

                                <div className="add-contact-box">
                                    <div className="form-group">
                                        <label className="form-label fw-bold mb-2">Free Chat</label>

                                        <div className="d-flex gap-4 mt-2">
                                            <div className="form-check">
                                                <input
                                                    className="form-check-input"
                                                    type="radio"
                                                    id="notFree"
                                                    name="freeChat"
                                                    value="notfree"
                                                    style={{ width: "15px", border: "2px soild black" }}
                                                    checked={amount === false}
                                                    onChange={() => setAmount(false)}
                                                />
                                                <label className="form-check-label" htmlFor="notFree">
                                                    Free
                                                </label>
                                            </div>

                                            <div className="form-check">
                                                <input
                                                    className="form-check-input"
                                                    type="radio"
                                                    id="free"
                                                    name="freeChat"
                                                    value="free"
                                                    style={{ width: "15px" }}
                                                    checked={amount === true}
                                                    onChange={() => setAmount(true)}
                                                />
                                                <label className="form-check-label" htmlFor="free">
                                                    Not Free
                                                </label>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="form-group mb-3 col-md-6">
                                        <label className="text-black font-w500">Free Price</label>
                                        <div className="contact-name">
                                            <input type="number" className="form-control" autoComplete="off"
                                                name="FreePerMin"
                                                placeholder="Enter Your Free Price"
                                                value={ReviewData?.FreePerMin || ''}
                                                onChange={(e) =>
                                                    setReviewData({
                                                        ...ReviewData,
                                                        FreePerMin: e.target.value
                                                    })
                                                }

                                            />
                                            <span className="validation-text"></span>
                                        </div>
                                    </div>



                                </div>
                            </div>

                            <div className="modal-footer">
                                <button
                                    type="button"
                                    style={{ color: "black" }}
                                    onClick={() => {
                                        updatefreechat();
                                    }}
                                    className="btn btn-success"

                                >
                                    {" "}
                                    <i className="flaticon-delete-1"></i> Save
                                </button>
                                <button
                                    type="button"
                                    onClick={() => {
                                        setFreeChatModel(false);

                                    }}
                                    className="btn btn-danger"
                                >
                                    {" "}
                                    <i className="flaticon-delete-1"></i> Close
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </Modal>



            <Modal
                className="modal fade "
                show={notbusymodel}
                onHide={setnotmodel}
                backdrop="static"

            >
                <div className="" role="document">
                    <div className="">
                        <form>
                            <div className="modal-header">
                                <h4 className="modal-title fs-20">Busy Model</h4>

                                <button
                                    type="button"
                                    className="btn-close"
                                    onClick={() => setnotmodel(false)}
                                    data-dismiss="modal"
                                ></button>
                            </div>

                            <div className="modal-body p-3">
                                <i
                                    className="flaticon-cancel-12 close"
                                    data-dismiss="modal"
                                ></i>


                                <div className="add-contact-box">
                                    <div className="form-group">
                                        <label className="form-label fw-bold mb-2">Busy Chat</label>

                                        <div className="d-flex gap-4 mt-2">


                                            <div className="form-check">
                                                <input
                                                    className="form-check-input"
                                                    type="radio"
                                                    id="free"
                                                    name="freeChat"
                                                    value="free"
                                                    defaultChecked
                                                    style={{ width: "15px" }}
                                                />
                                                <label className="form-check-label" htmlFor="free">Free</label>
                                            </div>


                                            <div className="form-check">
                                                <input
                                                    className="form-check-input"
                                                    type="radio"
                                                    id="notFree"
                                                    name="freeChat"
                                                    value="notfree"
                                                    disabled
                                                    style={{ width: "15px" }}
                                                />
                                                <label className="form-check-label" htmlFor="notFree">Busy</label>
                                            </div>

                                        </div>
                                    </div>
                                </div>

                            </div>

                            <div className="modal-footer">
                                <button
                                    type="button"
                                    style={{ color: "black" }}
                                    onClick={() => {
                                        updatenotbusychat();
                                    }}
                                    className="btn btn-success"

                                >
                                    {" "}
                                    <i className="flaticon-delete-1"></i> Save
                                </button>
                                <button
                                    type="button"
                                    onClick={() => {
                                        setnotmodel(false);
                                    }}
                                    className="btn btn-danger"
                                >
                                    {" "}
                                    <i className="flaticon-delete-1"></i> Close
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </Modal>





        </div>
    )
}
export default AstrologerList
